<div [ngClass]="{'small-size': !bigSize,'banner-container ': true }">
  <img class="img" src="{{serverUrl+bannerUrl}}" alt="first slide">
  <div class="banner-title">
    <div>{{title}}</div>
  </div>
</div>